import React from 'react'
import { NavLink } from 'react-router-dom'
const NavBar = () => {
  // let ac1=useState(true)
  // let ac2=useState(true)

  let navlinkactive=({isActive})=>{
    return{
      fontWeight:isActive?'bold':'normal',
      textDecoration:isActive?'none':'underline'
    }
  }
  return (
    <>
        <ul style={{display:"flex",justifyContent:"center",gap:"20px",listStyle:"none",fontSize:"20px"}}>
            <li ><NavLink style={{navlinkactive}}  to="/banking" >banking</NavLink></li>
            <li ><NavLink to="/todo" style={{navlinkactive}}>to-do list</NavLink></li>
            <li ><NavLink to="/thunk" style={{navlinkactive}}>redux thunk</NavLink></li>    
        </ul> 
    </>
  )
}

export default NavBar